import { useState } from 'react';

interface ImagePreviewState {
  src: string;
  alt: string;
}

export const useImagePreview = () => {
  const [previewImage, setPreviewImage] = useState<ImagePreviewState | null>(null);

  const openPreview = (src: string, alt: string = '') => {
    setPreviewImage({ src, alt });
  };

  const closePreview = () => {
    setPreviewImage(null);
  };

  return {
    previewImage,
    openPreview,
    closePreview,
    isOpen: previewImage !== null
  };
}; 